import $ from 'jquery';
import 'datatables.net';
import JSZip from 'jszip';
import 'datatables.net-buttons';
import 'datatables.net-plugins/sorting/absolute';
import pdfMake from 'pdfmake/build/pdfmake.js';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import flash from 'datatables.net-buttons/js/buttons.flash.js';
import html5 from 'datatables.net-buttons/js/buttons.html5.js';
import print from 'datatables.net-buttons/js/buttons.print.js';

function once(fn, context) {
    let result;
    return function () {
        if (fn) {
            result = fn.apply(context || this, arguments);
            fn = null;
        }
        return result;
    };
}

const init = function () {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    $.extend($.fn.dataTable.defaults, {
        language: {
            sEmptyTable: __('dataTable.empty')
        }
    });
};
const datatables = once(init);

export {datatables};
